export default __webpack_public_path__ + "static/media/bootstrap-logo.99d72763.png";